﻿$.fn.dxCtrlGridTemplate = function custom_dxCtrlGridTemplate(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlgridtemplate dx-ctrl");
        this.createInstance(new cdxCtrlGridTemplate(this, option));
    }
    return this;
}

window.cdxCtrlGridTemplate = function (container, option) {
    var Me = this;

    //option.typeDisplay grille/formulaire
    //option.readOnly true/false

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    _indexDashBoard += 1
    var indexInterne = _indexDashBoard

    var lstField = null
    //if (option.typeDisplay == "formulaire") {
    //    lstField.filter(function (item) { return typeof item.gridTemplate != 'undefined' }).forEach(function (item) {
    //        item.gridTemplate.gsw=20
    //    })
    //}
    this.pop = null
    var jauge = null
    var popContentElement = null
    function mConstruit() {
        container.empty();

        var title = "Modèle de présentation des données"
        if (option.justeChamp) {
            title = "Gestion champs base de données"
        }

        if (typeof option.inPopup == 'undefined' || option.inPopup) {
            var opt = {
                position: {
                    my: "right top",
                    at: "right top",
                    of: "body"
                },
                width: ((option.justeChamp) ? 450 : 850),
                height: "100%",
                showTitle: true,
                showMaximize: true,
                title: title,
                contentTemplate: function (contentElement) {
                    contentElement.css("padding-top", "0")
                    popContentElement = contentElement
                    mInit()
                },
                onHiding: function (e) {
                    jauge.mShow()
                    $(window).trigger("updateChamps");
                    if (typeof option.onClose != "undefined") {
                        window.setTimeout(function () { option.onClose() }, 0)
                    }
                }
            }

            Me.pop = container.appendTo("body").dxCtrlPopupBase(opt).dxCtrlPopupBase("instance")
            Me.pop.show();
        } else {
            popContentElement = container
            mInit()
        }


        function mInit() {
            //lstField = (new cFieldStrCon(option.bddCtrl)).mGetLstField()
            jauge = $("<div/>").appendTo(popContentElement).dxCtrlJauge({}).dxCtrlJauge("instance")
            jauge.mShow()
            lstTemplateChampTable = null
            mGetDataLstTemplateChampTable(function () {
                mRempli()
                //if (option.justeChamp) {
                //    lstField = (new cFieldStrCon(option.bddCtrl)).mGetLstField()
                //    mConstruitListSimple(popContentElement)
                //    jauge.mHide()
                //} else { mRempli() }
            })
        }
    }

    var contentElementPrevisualisation = null
    function mRempli() {
        popContentElement.empty()
        lstField = (new cFieldStrCon(option.bddCtrl)).mGetLstField()
        if (option.justeChamp) {
            mConstruitListSimple(popContentElement)
            jauge.mHide()
        } else {
            var $DivEntete = $("<div style='padding:5px;'/>").appendTo(popContentElement)
            var $Table = $("<table style='width:100%'/>").appendTo($DivEntete)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:100%'/>").appendTo($Tr)
            var txt = ((option.typeDisplay == "grille") ? "Modèle grille" : "Formulaire") + "" + ((option.typeDisplay == "grille") ? ((option.readOnly) ? " VISUALISATION" : " MODIFICATION") : "")
            $("<div>" + txt + "</div>").appendTo($Td)
            var txtPour = ((option.table.nom == "structures") ? "Pour des STRUCTURES" :
                ((option.table.nom == "structures_contact") ? "Pour des STRUCTURES/CONTACTS" :
                    ((option.table.nom == "contact") ? "Pour des CONTACTS ISOLES" :
                        ((option.table.nom == "compte_client") ? "Pour des COMPTE CLIENT" : "COMPTE CLIENT UTILISATEUR"))))
            $("<div>" + txtPour + "</div>").appendTo($Td)
            if (option.typeDisplay == "grille") $("<div>Vue <b>" + option.dataGridVue.nom + "</b></div>").appendTo($Td)
            var $Td = $("<td style='width:1px;padding-left:5px;border-left:" + theme.border + ";'/>").appendTo($Tr)
            var lstItems = []
            option.bddCtrl.mGetArray("template_form").filter(function (o) {
                return o.nom_table == option.table.nom &&
                    o.type_template == option.dataTemplateForm.type_template &&
                    o.id_template_form != option.dataTemplateForm.id_template_form
            }).forEach(function (o) {
                lstItems.push({
                    id: o.id_template_form,
                    name: o.nom,
                    icon: "fas fa-table",
                    data: o
                })
            })
            lstItems.unshift({
                id: 0,
                name: "Créer un nouveau modèle",
                icon: "fas fa-certificate",
                data: null
            })
            $("<div/>").appendTo($Td).dxDropDownButton({
                items: lstItems,
                text: option.dataTemplateForm.nom.decoupe(15),
                icon: 'fas fa-table',
                displayExpr: 'name',
                keyExpr: 'id',
                showDropDownButton: true,
                hint: "Créer ou sélectionner un nouveau modèle de présentation des données pour<br/><b>" + txt + "<br/>" + txtPour + "</b>",
                dropDownOptions: {
                    width: 300,
                },
                onItemClick(e) {
                    if (e.itemData.data == null) {
                        //création d'un nouveau template
                        var nom = "Modèle " + ((option.typeDisplay == "grille") ? "grille" : "formulaire") + ((option.typeDisplay == "grille") ? ((option.readOnly) ? " visu" : " modif") : "") +
                            ((option.table.nom == "structures") ? " structure" :
                                ((option.table.nom == "structures_contact") ? " structure/contact" :
                                    ((option.table.nom == "contact") ? " contact" :
                                        ((option.table.nom == "compte_client") ? " compte client" : " compte client utilisateur"))));
                        var idx = 1
                        while (option.bddCtrl.mGetArray("template_form").filter(function (o) { return o.nom == nom + " (" + idx + ")" }).length > 0) {
                            idx += 1
                        }
                        var newData = option.bddCtrl.getObjet("template_form").mGetNewData()
                        newData.nom = nom
                        newData.type_template = option.dataTemplateForm.type_template
                        newData.nom_table = option.dataTemplateForm.nom_table
                        newData.defaut = 0
                        newData.json = option.bddCtrl.getObjet("template_form").objetMetier.mGetJsonModeleDefaut(newData.type_template, newData.nom_table)
                        option.bddCtrl.getObjet(newData).mSave(function (data) {
                            option.dataTemplateForm = newData
                            option.bddCtrl.getObjet("template_form").objetMetier.mSetData(option.dataTemplateForm, option.dataGridVue.id_grid_vue)
                            mRempli()
                            mNotify("Votre modèle a été créé", "success", 6000)
                        })
                    } else {
                        option.dataTemplateForm = e.itemData.data
                        option.bddCtrl.getObjet("template_form").objetMetier.mSetData(option.dataTemplateForm, option.dataGridVue.id_grid_vue)
                        mRempli()
                        mNotify("Votre modèle a été sélectionné", "success", 6000)
                    }
                }
            });

            if (option.dataTemplateForm.defaut == "0") {
                var $Table = $("<table style='width:100%'/>").appendTo($DivEntete)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlTextBox({
                    labelMode: 'floating',
                    label: "Nom du modèle",
                    value: option.dataTemplateForm.nom,
                    onValueChanged: function (e) {
                        if (e.value == null || e.value.length == 0) { e.component.option("value", option.dataTemplateForm.nom) }
                        else {
                            option.dataTemplateForm.nom = e.value
                            option.bddCtrl.getObjet(option.dataTemplateForm).mSaveChamp("nom")
                        }
                    }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-trash-alt",
                    onClick: function (e) {
                        option.bddCtrl.getObjet(option.dataTemplateForm).mDelData()
                        option.dataTemplateForm = option.bddCtrl.getObjet("template_form").objetMetier.mGetDataDefaut(option.dataTemplateForm.type_template, option.dataTemplateForm.nom_table)
                        mRempli()
                    }
                })
            }

            var $Table = $("<table style='width:100%'/>").appendTo($DivEntete)
            var $Tr = $("<tr/>").appendTo($Table)
            if (typeof option.displayGestionChamp == 'undefined' || option.displayGestionChamp) {
                var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                mAddButtonGestionChamp($Td)
            }


            var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
            var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlButton({
                icon: "fas fa-refresh",
                text: "Réinitialiser",
                hint: "Permet de recharger le modèle de " + option.typeDisplay + " de base<br/>(celui qui était initialement utilisé au démarrage de l'application)",
                onClick: function (e) {
                    if (option.readOnly) {
                        option.dataTemplateForm.json = option.bddCtrl.getObjet("template_form").objetMetier.jsonTemplateVisu
                    } else {
                        if (option.typeDisplay == "grille") {
                            switch (option.table.nom) {
                                case "structures": option.dataTemplateForm.json = option.bddCtrl.getObjet("template_form").objetMetier.jsonTemplateStrModif; break;
                                case "structures_contact": option.dataTemplateForm.json = option.bddCtrl.getObjet("template_form").objetMetier.jsonTemplateStrConModif; break;
                                case "contact": option.dataTemplateForm.json = option.bddCtrl.getObjet("template_form").objetMetier.jsonTemplateConModif; break;
                                //case "compte_client": option.dataTemplateForm.json = option.bddCtrl.getObjet("template_form").objetMetier.jsonTemplateCptCliModif; break;
                                //case "compte_client_utilisateur": option.dataTemplateForm.json = option.bddCtrl.getObjet("template_form").objetMetier.jsonTemplateCptCliUtiModif; break;
                            }
                        } else {
                            switch (option.table.nom) {
                                case "structures":
                                    option.dataTemplateForm.json = option.bddCtrl.getObjet("template_form").objetMetier.jsonTemplateFormulaireStr;
                                    break;
                                case "structures_contact":
                                    option.dataTemplateForm.json = option.bddCtrl.getObjet("template_form").objetMetier.jsonTemplateFormulaireStrCon;
                                    break;
                                case "contact":
                                    option.dataTemplateForm.json = option.bddCtrl.getObjet("template_form").objetMetier.jsonTemplateFormulaireCon;
                                    break;
                                //case "compte_client":
                                //    option.dataTemplateForm.json = option.bddCtrl.getObjet("template_form").objetMetier.jsonTemplateFormulaireCptCli;
                                //    break;
                                //case "compte_client_utilisateur":
                                //    option.dataTemplateForm.json = option.bddCtrl.getObjet("template_form").objetMetier.jsonTemplateFormulaireCptCliUti;
                                //    break;
                            }
                        }
                    }
                    option.bddCtrl.getObjet(option.dataTemplateForm).mSaveChamp("json")
                    mRempli()
                }
            })

            var $DivSplitter = $("<div style='height:calc(100% - " + $DivEntete.innerHeight() + "px);'/>").appendTo(popContentElement)
            var ctrlResize = $("<div/>").appendTo($DivSplitter).dxCtrlSplitterResize2({
                bddCtrl: option.bddCtrl,
                collapsibleLeft: false,
                context_grid: "splitterpersogrid",
                widthLeftInitial: 250
            }).dxCtrlSplitterResize2("instance")

            ctrlResize.element().find(".dx-resize-handle").css("background-color", theme.backgroundcolorTooltip)
            ctrlResize.mConstruitLeft(function (contentElementLeft) {
                mConstruitList(contentElementLeft)
            })

            ctrlResize.mConstruitRight(function (contentElementRight) {
                window.setTimeout(function () {
                    mConstruitConstructor(contentElementRight)
                    jauge.mHide()
                }, 500)
                //window.setTimeout(function () {
                //    var ctrlResize2 = $("<div/>").appendTo(contentElementRight).dxCtrlSplitterResize2({
                //        bddCtrl: option.bddCtrl,
                //        orientation: "vertical",
                //        collapsibleLeft: false,
                //        context_grid: "splitterpersogridinner",
                //        widthLeftInitial: 300
                //    }).dxCtrlSplitterResize2("instance")

                //    //constructeur du template
                //    ctrlResize2.mConstruitLeft(function (contentElementLeft) {
                //    })

                //    //visualisateur du template
                //    ctrlResize2.mConstruitRight(function (contentElementLeft) {
                //        contentElementPrevisualisation = contentElementLeft
                //        contentElementPrevisualisation.css("position", "relative")
                //        mConstruitPrevisualisation()
                //    })
                //}, 500)
            })
            //})

            resizeObserver.mAdd($DivEntete, function () { $DivSplitter.css("height", "calc(100% - " + $DivEntete.innerHeight() + "px)") })
            function mSurveilleRemoveDom() {
                if (container.closest("body").length == 0) {
                    if (grid) grid.destroy()
                    return;
                }
                window.setTimeout(function () { mSurveilleRemoveDom() }, 250)
            }
            mSurveilleRemoveDom()
        }
        //lstField = (new cFieldStrCon(option.bddCtrl)).mGetLstField()
        ////jauge = $("<div/>").appendTo(popContentElement).dxCtrlJauge({}).dxCtrlJauge("instance")
        ////jauge.mShow()
        ////lstTemplateChampTable = null
        ////mGetDataLstTemplateChampTable(function () {
        ////    //mInitTemplate(function () { 


        //})
    }

    function mAddButtonGestionChamp($Ele) {

        var $Table = $("<table style='width:1px'/>").appendTo($Ele)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        $("<div style='display:inline-block'/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-server",
            icon2: "fas fa-certificate",
            colorIcone2: theme.colorBtIcon2,
            opacityIcone3: 0.6,
            height: HeightButton,
            width: HeightButton,
            txtTooltip: "Créer un nouveau champ de données...",
            onClick: function (e) {
                $("<div/>").appendTo("body").dxCtrlChampChoixTooltip({
                    bddCtrl: option.bddCtrl,
                    target: e.component.element(),
                    onItemClick: function (e) {
                        e.event.preventDefault();
                        e.event.stopPropagation();
                        var dataChampTable = option.bddCtrl.getObjet("champ_table").mGetNewData()
                        dataChampTable.id_type_champ = e.itemData
                        dataChampTable.nom = "Nouveau champ"
                        jaugeDemarrage.mShow()
                        option.bddCtrl.getObjet(dataChampTable).mSave(function (data, dataObjet) {
                            dataChampTable = dataObjet
                            mRempli()
                            $("<div/>").appendTo("body").dxCtrlPopupChampTableConfig({
                                bddCtrl: option.bddCtrl,
                                data: dataChampTable,
                                onChange: function () {
                                    mRempli()
                                }
                            })
                            jaugeDemarrage.mHide()
                        })
                        //$("<div/>").appendTo("body").dxCtrlPopupChampTableConfig({
                        //    bddCtrl: option.bddCtrl,
                        //    data: field.dataChampTable,
                        //    onChange: function () {
                        //        mRempli()
                        //    }
                        //})
                        //jaugeDemarrage.mShow()
                        //window.setTimeout(function () {
                        //    option.bddCtrl.getObjet("champ_table_config").objetMetier.mShowNewChampTable(e.itemData, option.id_table, function () {
                        //        mRempli()
                        //    })
                        //    jaugeDemarrage.mHide()
                        //}, 0)
                    }
                })
            }
        })
        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        $("<div style='display:inline-block'/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-server",
            icon2: "fas fa-object-group",
            colorIcone2: theme.colorBtIcon2,
            opacityIcone3: 0.6,
            height: HeightButton,
            width: HeightButton,
            txtTooltip: "Fusionner des champs de données<br>(Permet de rassembler plusieurs champ en un seul<br/>ou de changer le type d'un champ)",
            onClick: function (e) {
                var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                    width: 450,
                    height: "auto",
                    fullScreen: false,
                    showMaximize: false,
                    title: "Fusionner des champs de données",
                    contentTemplate: function (contentElement) {
                        contentElement.css("padding", "25px")
                        $("<div/>").appendTo(contentElement).dxCtrlChampTableFusion({
                            bddCtrl: option.bddCtrl,
                            onValide: function () {
                                jaugeDemarrage.mShow()
                                window.setTimeout(function () {
                                    popup.hide()
                                    Me.pop.hide()
                                    if (typeof option.onClose != 'undefined') option.onClose()
                                    forcerFermetureNavigateur = true;
                                    window.location.reload()
                                }, 300)
                            },
                            onCancel: function () {
                                popup.hide()
                            }
                        }).dxCtrlChampTableFusion("instance")
                    }
                }).dxCtrlPopupBase("instance")
                popup.show()
            }
        })
    }
    var grid = null
    var disableSave = false
    function mConstruitConstructor(contentElement) {
        if (grid) grid.destroy()
        contentElement.empty()
        var $DivDashBoard = $("<div id='indexdashboard" + indexInterne + "' class='grid-stack indexdashboard" + indexInterne + "' style='height:100%;width:100%;border:" + theme.border + ";'/>").appendTo(contentElement)
        grid = GridStack.init({
            class: "indexdashboard" + indexInterne,
            alwaysShowResizeHandle: false,
            margin: 0,
            cellHeight: 40,
            acceptWidgets: true,
            removable: true,
            float: false,
            column: 20
        }, $DivDashBoard[0]);
        GridStack.setupDragIn('.newItemDataGrid', { appendTo: 'body', helper: "clone" })

        //grid.on('drag', function (e, el) {
        //    dxSCrollList.option("disabled", true)
        //});
        if (grid == null) return //cas on a fermé la fenêtre avant la construction de la grille
        var timeOutConstruitPrevi = null
        grid.on('added', function (e, items) {
            //on a glissé un nouvel élément
            var field = lstField.filter(function (o) { return o.dataField == $(items[0].el).attr("key") })[0]
            var content = $($(items[0].el).find(".grid-stack-item-content"))
            //content.attr("style","")
            content.css({
                "cursor": "move",
                "display": "flex",
                "align-items": "center"
            })
            content.empty()
            if (typeof field.gridTemplate.itemTemplate != 'undefined') {
                field.gridTemplate.itemTemplate(content)
            } else {
                $("<div style='font-size:90%;font-family:barlow condensed;padding:2px;' key='" + field.dataField + "'>" + ((typeof field.icon != 'undefined') ? "<i class='" + field.icon + " dx-theme-accent-as-text-color' style='margin-right:5px;width:18px;'></i>" : "") + field.caption + "</div>").appendTo(content)
            }

            items[0].dataField = field.dataField
            mSave()
        })

        grid.on('change', function (e, items) {
            mSave()
            //mConstruitPrevisualisation()
        });
        grid.on('removed', function (e, items) {
            mSave()
            //mConstruitPrevisualisation()
        })

        var disableConstruitPrevi = true
        disableSave = true
        var jsonParsed = JSON.parse(option.dataTemplateForm.json)
        var lstDel = []
        jsonParsed.forEach(function (item) {
            var field = lstField.filter(function (o) { return o.dataField == item.dataField })[0]
            if (typeof field != 'undefined') {
                var $DivTemplate = mGetElementTemplate(field)
                $DivTemplate.attr("gs-x", item.x)
                $DivTemplate.attr("gs-y", item.y)
                $DivTemplate.attr("gs-w", item.w)
                $DivTemplate.attr("gs-h", item.h)
                item.el = $DivTemplate[0]
                grid.addWidget(item)
            } else {
                lstDel.push(item)
            }
        })

        disableSave = false
        disableConstruitPrevi = false
        //mConstruitPrevisualisation()

        if (lstDel.length > 0) {
            lstDel.forEach(function (item) {
                jsonParsed.splice(jsonParsed.indexOf(item), 1)
            })
            mSave()
        }
    }

    function mSave() {
        if (disableSave) return
        var serializedData = grid.save()
        var data = []
        serializedData.forEach(function (itemGrid) {
            if (typeof itemGrid.w == 'undefined') itemGrid.w = 1
            if (typeof itemGrid.h == 'undefined') itemGrid.h = 1
            data.push({
                x: itemGrid.x,
                y: itemGrid.y,
                w: itemGrid.w,
                h: itemGrid.h,
                dataField: itemGrid.dataField
            })
        })
        option.dataTemplateForm.json = JSON.stringify(data)
        option.bddCtrl.getObjet(option.dataTemplateForm).mSaveChamp("json")
        //option.onValueChanged(option.json)
        ////option.value.json = JSON.stringify(data)
        ////option.bddCtrl.getObjet(option.value).mSaveChamp("json")
    }
    function mConstruitPrevisualisation() {
        contentElementPrevisualisation.empty()
        var jauge = $("<div/>").appendTo(contentElementPrevisualisation).dxCtrlJauge({}).dxCtrlJauge("instance")
        jauge.mShow()
        contentElementPrevisualisation.css("padding", "0 5px")
        $("<div style='height:100%;width:100%;position:absolute;z-index:2;'/>").appendTo(contentElementPrevisualisation)
        var $Table = $("<table style='width:100%;position:absolute;z-index:1;'/>").appendTo(contentElementPrevisualisation)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td rowspan='1' style='width:0px;vertical-align:top;padding-right:5px;'><span style='font-size:250%;font-weight:bold;transform: rotate(180deg);writing-mode: tb-rl;padding-bottom:10px;'>Prévisualisation</span></td>").appendTo($Tr)
        if (option.table.nom == "structures") {
            var $Td = $("<td style='width:0px;font-size:300%;'><i class='fas fa-home'></i></td>").appendTo($Tr)
        } else if (option.table.nom == "structures_contact") {
            var $Td = $("<td style='width:0px;font-size:300%;'/>").appendTo($Tr)
            option.bddCtrl.getObjet("structures_contact").mGetIcone().appendTo($Td);
        } else if (option.table.nom == "contact") {
            var $Td = $("<td style='width:0px;font-size:300%;'><i class='fas fa-portrait'></i></td>").appendTo($Tr)
        }
        var $Td = $("<td style='width:100%;padding:10px 5px;'/>").appendTo($Tr)
        var $Div = $("<div style='padding:10px;border:" + theme.border + ";'/>").appendTo($Td)
        var dxTemplate = $("<div style=''/>").appendTo($Div).dxCtrlItemGridTemplate({
            bddCtrl: option.bddCtrl,
            type: "Détails",
            dataTemplateDisplay: option.dataTemplate,
            dataTemplatePlus: option.dataTemplate,
            dataGrid: dataGrid,
            showDossier: false,
            optionTemplate: {
                dataGridVue: option.dataGridVue,
                fields: lstField,
                onChange: ((option.readOnly) ? null : function (dataTemplate) { }),
                typeDisplay: option.typeDisplay,
            }
        }).dxCtrlItemGridTemplate("instance")
        jauge.mHide()

    }

    function mConstruitList(contentElement, typeNiveau) {
        contentElement.empty()

        var dxRdType = $("<div style='display:none'/>").appendTo(contentElement).dxRadioGroup({
            dataSource: ["Simple", "Avancé"],
            value: ((typeof typeNiveau == "undefined") ? "Simple" : typeNiveau),
            focusStateEnabled: false,
            layout: "horizontal",
            onValueChanged: function (e) {
                mConstruitList(contentElement, e.value)
            }
        }).dxRadioGroup("instance")
        //var $DivDetail = $("<div style='height:calc(100% - " + (2 + dxRdType.element().innerHeight()) + "px);width:100%;'/>").appendTo(contentElement)
        var $DivDetail = $("<div style='height:calc(100% - 0px);width:100%;'/>").appendTo(contentElement)
        switch (dxRdType.option("value")) {
            case "Simple": mConstruitListSimple($DivDetail); break;
            case "Avancé": mConstruitListAvance($DivDetail); break;
        }

    }

    var scrollTopSimple = 0
    var dxScrollListSimple = null
    var firstLoadListSimple = true
    function mConstruitListSimple(contentElement) {
        firstLoadListSimple = true;
        contentElement.empty()
        var $DivEnt = null
        if (option.justeChamp && (typeof option.displayGestionChamp == 'undefined' || option.displayGestionChamp)) {
            $DivEnt = $("<div/>").appendTo(contentElement)
            mAddButtonGestionChamp($DivEnt)
        }
        //$("<div/>").appendTo(contentElement).dxCtrlLstChampSimple({
        //    bddCtrl: option.bddCtrl,
        //    lstField:lstField,
        //    showGrpChamp:(option.typeDisplay == "grille" && option.readOnly),
        //    GridStack: GridStack
        //})
        var ds = []
        if (!option.justeChamp && option.typeDisplay == "grille" && option.readOnly) {
            ds.push({ id: 0, title: "Groupe de champs", key: "grpchamps", hint: "Groupe de champs représentant la visualisation d'un élément." })
        }

        //ds.push({ id: 1, title: "Champs par défaut", key: "champsdefaut", hint: "Champs par défaut de l'élément<br/>(adresse email, adresse postale, téléphone...).<br/>Exemple: Si un contact à plusieurs téléphones,<br/>affiche le numéro de téléphone par défaut" })
        ds.push({ id: 2, title: "Champs initiaux application", key: "champsinitial", hint: "Champs initiaux de l'application<br/>(adresse email, adresse postale, téléphone...)" })
        if (option.bddCtrl.objCptCli.objetMetier.hasDocCpt()) ds.push({ id: 3, title: "Champs administratifs", key: "champadmin", hint: "Liste des champs liés à votre facturation (APE, Tva intra, siret...)" })
        if (option.bddCtrl.nom_base.endsWith("_aagest")) ds.push({ id: 4, title: "Champs comptes clients", key: "champcptcli" })
        ds.push({ id: 5, title: "Champs personnalisés", key: "champperso", hint: "Liste des champs que vous avez créés" })
        var lstFieldAccord = lstField.filter(function (o) { return typeof o.gridTemplate != 'undefined' })
        dxScrollListSimple = $("<div style='height:calc(100% - " + (($DivEnt == null) ? 0 : $DivEnt.innerHeight()) + "px);'/>").appendTo(contentElement).dxScrollView({
            onScroll: function (e) {
                scrollTopSimple = e.component.scrollTop()
            }
        }).dxScrollView("instance")
        var selectedItems = ds
        if (option.justeChamp) selectedItems = [ds[ds.length - 1]]
        var dxAccordSimple = $("<div/>").appendTo(dxScrollListSimple.content()).dxAccordion({
            dataSource: ds,
            multiple: true,
            collapsible: true,
            selectedItems: selectedItems,
            itemTitleTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.addClass("dx-theme-accent-as-text-color")
                itemElement.css("font-weight", "bold")
                itemElement.text(itemData.title)
                itemElement.attr("title", itemData.hint)
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("padding", "5px")
                var lstField = []
                switch (itemData.id) {
                    case 0:
                        lstField = lstFieldAccord.filter(function (o) { return o.id == 'resume_detail' || o.id == 'resume_ligne' })
                        break;
                    case 1:
                        lstField = lstFieldAccord.filter(function (o) { return o.dataField.startsWith('champsdefaut.') && typeof o.gridTemplate.editTemplate != 'undefined' })
                        break;
                    case 2:
                        lstField = lstFieldAccord.filter(function (o) { return o.id_parent == 'champsinitial' && typeof o.gridTemplate.editTemplate != 'undefined' })
                        if (typeof option.table != "undefined") {
                            switch (option.table.nom) {
                                case "structures":
                                    //enleve le nom/prénom contact
                                    lstField = lstField.filter(function (o) { return o.dataField != "champsinitial.champtable_" + parametre.champ.id_champ_table_nomprenom })
                                    break;
                                case "structures_contact":
                                    if (option.typeDisplay == "formulaire") {
                                        lstField = lstField.filter(function (o) { return o.dataField != "champsinitial.champtable_" + parametre.champ.id_champ_table_nomprenom })
                                        lstField = lstField.filter(function (o) { return o.dataField != "champsinitial.champtable_" + parametre.champ.id_champ_table_nomstructure })
                                    }
                                    break;
                                case "contact":
                                    lstField = lstField.filter(function (o) { return o.dataField != "champsinitial.champtable_" + parametre.champ.id_champ_table_nomstructure })
                                    break;
                            }
                        }
                        break;
                    case 3:
                        lstField = lstFieldAccord.filter(function (o) { return o.id_parent == 'champadmin' && typeof o.gridTemplate.editTemplate != 'undefined' })
                        break;
                    case 4:
                        lstField = lstFieldAccord.filter(function (o) { return o.id_parent == 'champcptcli' && typeof o.gridTemplate.editTemplate != 'undefined' })
                        break;
                    case 5:
                        lstField = lstFieldAccord.filter(function (o) { return o.id_parent == 'champperso' && typeof o.gridTemplate.editTemplate != 'undefined' })
                        break;
                }
                if (lstField.length == 0) {
                    $("<div style='text-align:center;opacity:0.5;padding:20px;'>(aucun champ)</div>").appendTo(itemElement)
                } else {
                    lstField.forEach(function (item) {
                        var $Div = $("<div style='padding:0 5px 5px 5px;cursor:default;position:relative;'/>").appendTo(itemElement)
                        var ele = mGetElementTemplate(item).appendTo($Div)
                        mAddElementInList(item, $Div)
                    })
                }
            },
            onContentReady: function (e) {
                if (!option.justeChamp) GridStack.setupDragIn('.newItemDataGrid', { appendTo: 'body', helper: "clone" })
                if (firstLoadListSimple) window.setTimeout(function () { dxScrollListSimple.scrollTo(scrollTopSimple + 60) }, 0)
                firstLoadListSimple = false
            }
        })
    }
    function mConstruitListAvance(contentElement) {
        contentElement.empty()
        $("<div style='height:100%;'/>").appendTo(contentElement).dxTreeView({
            items: lstField.filter(function (o) { return typeof o.gridTemplate != 'undefined' }),
            dataStructure: 'plain',
            parentIdExpr: 'id_parent',
            keyExpr: 'id',
            useNativeScrolling: true,
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.parent().css("padding", "5px")
                itemElement.parent().css("cursor", "default")
                itemElement.parent().css("position", "relative")
                if (typeof itemData.gridTemplate.contentTemplate != 'undefined') {
                    var ele = mGetElementTemplate(itemData).appendTo(itemElement)
                    mAddElementInList(itemData, ele)
                } else {
                    var $Div = $("<div class='' key='" + itemData.dataField + "' style='padding:3px;position:relative;'></div>").appendTo(itemElement)
                    var $DivContainer = $('<div class=""></div>').appendTo($Div)
                    $("<div style='vertical-align:top'><span style='font-size:120%;font-family:barlow condensed;'>" +
                        ((typeof itemData.icon != 'undefined') ? "<i class='" + itemData.icon + " dx-theme-accent-as-text-color' style='margin-right:5px;width:24px;'></i>" : "") +
                        itemData.caption + "</span></div>").appendTo($DivContainer)
                    if (typeof itemData.gridTemplate.hint != 'undefined') { $Div.attr("title", itemData.gridTemplate.hint) }
                    else if (typeof itemData.hint != 'undefined') { $Div.attr("title", itemData.hint) }
                    else { $Div.attr("title", itemData.caption) }
                }
            },
            onItemExpanded: function (e) {
                if (!option.justeChamp) GridStack.setupDragIn('.newItemDataGrid', { appendTo: 'body', helper: "clone" })
            },
            onContentReady: function (e) {
            }
        })
    }

    function mAddElementInList(field, $Ele) {
        var dataTemplateChampTable = null
        if (typeof field.dataChampTable != 'undefined' && field.dataChampTable != null) {
            dataTemplateChampTable = lstTemplateChampTable.filter(function (o) {
                return o.id_champ_table == field.dataChampTable.id_champ_table
            })[0]
        }
        if (dataTemplateChampTable != null && dataTemplateChampTable != "undefined") {
            var nb = dataTemplateChampTable.nbstr + dataTemplateChampTable.nbstrcon + dataTemplateChampTable.nbcon// + dataTemplateChampTable.nbcptcli + dataTemplateChampTable.nbcptcliuti
            if (nb > 0) {
                $("<div style='position:absolute;top:0;right:0;background-color:gray;border-radius:50%;font-size:80%;padding:2px 5px;top:-2px;font-family:barlow condensed;'>" + nb + "</div>").appendTo($Ele)
                //var $Div2 = option.bddCtrl.getObjet("champ_table").objetMetier.mGetElementUse(dataTemplateChampTable, option.bddCtrl)
            }
        }

        if (typeof field.dataChampTable != 'undefined' && field.dataChampTable != null) {
            var dxBt = $("<div style='position:absolute;top:-2px;right:0;display:none;'/>").appendTo($Ele).dxCtrlButton({
                icon: "fas fa-pen",
                onClick: function (e) {
                    e.event.preventDefault();
                    e.event.stopPropagation();
                    $("<div/>").appendTo("body").dxCtrlPopupChampTableConfig({
                        bddCtrl: option.bddCtrl,
                        data: field.dataChampTable,
                        dataField: field,
                        popupLstChamp: Me.pop,
                        onChange: function () {
                            mRempli()
                        }
                    })
                }
            }).dxCtrlButton("instance")
            $Ele.on("mouseleave", function () { dxBt.element().css("display", "none") })
            $Ele.on("mouseenter", function () { dxBt.element().css("display", "") })
        }
    }
    function mGetElementTemplate(field) {
        var dataTemplateChampTable = null
        if (typeof field.dataChampTable != 'undefined' && field.dataChampTable != null) {
            dataTemplateChampTable = lstTemplateChampTable.filter(function (o) {
                return o.id_champ_table == field.dataChampTable.id_champ_table
            })[0]
        }

        var $Div = $("<div class='' key='" + field.dataField + "' style='padding:3px;'></div>")
        var $DivContainer = $('<div class=""></div>').appendTo($Div)
        var icon = "<i class='" + field.icon + " dx-theme-accent-as-text-color' style='margin-right:5px;width:20px;'></i>"
        if (typeof field.gridTemplate.editTemplate != "undefined" && typeof option.onClickItemDataChamp == 'undefined') {
            var icon = "<i class='" + field.icon + " dx-theme-accent-as-text-color' style='margin-right:5px;width:20px;position:relative;'>" +
                "<i class='fas fa-pen' style='position:absolute;bottom:0;right:0;font-size:70%;color:" + theme.colorBtIcon2 + ";'></i>" +
                "</i>"
        }
        $("<div style='vertical-align:top;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;'>" + icon + "<span style='font-size:120%;font-family:barlow condensed;'>" +
            field.caption + "</span></div>").appendTo($DivContainer)
        if (typeof field.gridTemplate.contentTemplate != 'undefined') {
            $Div.css({
                border: theme.border
            })
            if (!option.justeChamp) $Div.addClass("newItemDataGrid grid-stack-item state-hover")
            $Div.attr("gs-x", "0")
            $Div.attr("gs-y", "0")
            $Div.attr("gs-w", ((typeof field.gridTemplate.gsw != 'undefined') ? field.gridTemplate.gsw : "5"))
            $Div.attr("gs-h", ((typeof field.gridTemplate.gsh != 'undefined') ? field.gridTemplate.gsh : "1"))
            $DivContainer.addClass("grid-stack-item-content")
        }
        if (typeof option.onClickItemDataChamp != 'undefined') {
            $Div.addClass("state-hover")
            $Div.on("click", function () {
                option.onClickItemDataChamp(field.dataChampTable)
            })
        }

        var hint = ""
        if (typeof field.hint != 'undefined') { hint = field.hint }
        else if (typeof field.gridTemplate.hint != 'undefined') { hint = field.gridTemplate.hint }
        else { hint = field.caption }
        if (typeof field.gridTemplate.editTemplate != "undefined") $Div.attr("title", hint)

        if (dataTemplateChampTable != null && dataTemplateChampTable != "undefined") {
            var nb = dataTemplateChampTable.nbstr + dataTemplateChampTable.nbstrcon + dataTemplateChampTable.nbcon// + dataTemplateChampTable.nbcptcli + dataTemplateChampTable.nbcptcliuti
            if (nb > 0) {
                var $Div2 = option.bddCtrl.getObjet("champ_table").objetMetier.mGetElementUse(dataTemplateChampTable, option.bddCtrl)
                hint += "<br/>" + $Div2.attr("title")
            }
        }

        $Div.attr("title", hint)

        return $Div
    }

    var lstTemplateChampTable = null
    function mGetDataLstTemplateChampTable(funcOk) {
        if (lstTemplateChampTable == null) {
            var lstIdTableIdTemplate = []
            option.bddCtrl.mGetArray("champ_table").forEach(function (dataChampTable) {
                lstIdTableIdTemplate.push({
                    id_table: option.bddCtrl.getObjet("champ_table").mGetTable().id_table,
                    id: dataChampTable.id_champ_table
                })
            })
            option.bddCtrl.mAjaxCall({ command: "getlstdatavirtualgrid", data: lstIdTableIdTemplate }, function (data) {
                lstTemplateChampTable = ((typeof data.lstdatatemplate == 'undefined') ? [] : data.lstdatatemplate)
                funcOk()
            })
        } else { funcOk() }
    }

    this.element = function () { return container }
    this.component = function () { return dx }

    mConstruit();
}